import projectTasksComponent from './project-tasks.component';

const projectTasksModule = angular.module('projectTasks', [])
  .component('projectTasks', projectTasksComponent)
  .name;

export default projectTasksModule;
